export enum TaxAndReportingOnboardingStep {
  GENERATE_COMPLIANCE_CALENDAR = 'GENERATE_COMPLIANCE_CALENDAR',
  ONBOARD_ENTITY = 'ONBOARD_ENTITY',
  BOOK_A_CALL = 'BOOK_A_CALL',
}

export type TTaxAndReportingOnboardingInformation = {
  currentStep: TaxAndReportingOnboardingStep | null;
  completedSteps: TaxAndReportingOnboardingStep[];
  availableSteps: TaxAndReportingOnboardingStep[];
  corporationId: number;
};

export type TTaxAndReportingOnboarding = {
  corporation: {
    id: number;
  };
  onboardingInformation: TTaxAndReportingOnboardingInformation;
  status: string;
};
